import axios from "axios"
const route = 'budget/expense_paid'
const Cost = {
    namespaced: true,

    state: () => ({}),

    getters: {},

    mutations: {},
    actions: {
        index(context,data) {
            return axios.get(route+`?chess_gestao_cost_center=${data.chess_gestao_cost_center}&month=${data.month}&year=${data.year}`)
        },
        indexDetails(context,data) {
            return axios.get(route+`/details?chess_gestao_cost_center=${data.chess_gestao_cost_center}&month=${data.month}&year=${data.year}`)
        },
        update(){
            return axios.get(route+'/update')
        },

        //carrega os centros de custo do chess gestao
        getChessGestaoCostCenter(){
            return axios.get(route+'/chess_gestao_cost_center')
        }

    }

}

export default Cost
